import React from 'react';

function LogoDark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84.671"
      height="50"
      viewBox="0 0 84.671 50"
    >
      <g transform="translate(-208.73 -125.305)">
        <g
          fill="#355b6a"
          data-name="Group 7520"
          transform="translate(208.73 163.241)"
        >
          <path
            d="M213.334 337.98c3.825 0 5.693 1.3 5.693 5.988 0 4.672-1.868 6.074-5.693 6.074h-4.6V337.98zm-.225 1.972h-2.095v8.117h2.095c2.665 0 3.479-.675 3.479-4.084 0-3.548-.815-4.033-3.479-4.033z"
            data-name="Path 1851"
            transform="translate(-208.73 -337.98)"
          ></path>
          <path
            d="M290.431 350.052h-2.786a158.748 158.748 0 00-5.313-9.086v9.086H280.1V337.99h2.995c1.748 2.752 3.5 5.763 5.072 8.706v-8.706h2.266v12.062z"
            data-name="Path 1852"
            transform="translate(-267.354 -337.988)"
          ></path>
          <path
            d="M354.26 347.031h-5.279c-.346 1.073-.657 2.095-.936 3.011h-2.405c1.143-3.6 2.907-8.463 4.379-12.062h3.581c1.229 3.875 2.995 8.844 4.345 12.062h-2.527c-.345-.865-.76-1.904-1.158-3.011zm-2.8-7.113a139.14 139.14 0 00-1.87 5.158h4.01c-.623-1.782-1.211-3.6-1.679-5.158z"
            data-name="Path 1853"
            transform="translate(-321.19 -337.98)"
          ></path>
          <path
            d="M424.023 365.01h-2.664c-.346-1.782-1-4.516-1.418-5.9a61.979 61.979 0 01-1.7 5.9H415.6c-.848-3.063-1.816-6.109-2.838-8.81h2.266a60.9 60.9 0 012.007 6.611c.605-1.766 1.539-5.036 1.9-6.611h2.095c.571 1.713 1.368 4.725 1.782 6.611a60.391 60.391 0 002.043-6.611h2.181a83.228 83.228 0 01-3.013 8.81z"
            data-name="Path 1854"
            transform="translate(-376.323 -352.946)"
          ></path>
          <path
            d="M502.047 365.01H499.9v-8.81h2.147z"
            data-name="Path 1855"
            transform="translate(-447.902 -352.946)"
          ></path>
          <path
            d="M528.253 356.2v.432c-1.247 2.007-3.375 5.036-4.534 6.508h4.413v1.868h-7.772v-.432c1.679-2.129 3.74-5.088 4.6-6.508h-4.309V356.2z"
            data-name="Path 1856"
            transform="translate(-464.708 -352.946)"
          ></path>
        </g>
        <g data-name="Group 7534" transform="translate(247.847 132.324)">
          <g data-name="Group 7522" transform="translate(12.893 15.279)">
            <g data-name="Group 7521">
              <path
                fill="#597b8b"
                d="M0 0H11.46V1.429H0z"
                data-name="Rectangle 4767"
                transform="rotate(-87.88 5.944 5.728)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7525" transform="translate(0 11.297)">
            <g data-name="Group 7523">
              <path
                fill="#597b8b"
                d="M0 0H12.351V1.429H0z"
                data-name="Rectangle 4768"
                transform="rotate(-87.151 6.483 6.168)"
              ></path>
            </g>
            <g data-name="Group 7524" transform="translate(4.282 .009)">
              <path
                fill="#597b8b"
                d="M0 0H14.68V1.429H0z"
                data-name="Rectangle 4769"
                transform="rotate(-86.221 7.823 7.323)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7527" transform="translate(8.564 12.542)">
            <g data-name="Group 7526">
              <path
                fill="#597b8b"
                d="M0 0H15.31V1.429H0z"
                data-name="Rectangle 4770"
                transform="rotate(-86.663 8.1 7.642)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7529" transform="translate(20.979 11.911)">
            <g data-name="Group 7528">
              <path
                fill="#597b8b"
                d="M0 0H1.429V11.792H0z"
                data-name="Rectangle 4771"
                transform="rotate(-47.103 1.201 .523)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7533" transform="translate(22.53)">
            <g data-name="Group 7530" transform="translate(4.995)">
              <path
                fill="#597b8b"
                d="M0 0H1.429V12.683H0z"
                data-name="Rectangle 4772"
                transform="rotate(-46.3 1.207 .516)"
              ></path>
            </g>
            <g data-name="Group 7531" transform="translate(1.639 3.191)">
              <path
                fill="#597b8b"
                d="M0 0H1.429V15.337H0z"
                data-name="Rectangle 4773"
                transform="rotate(-46.803 1.204 .521)"
              ></path>
            </g>
            <g data-name="Group 7532" transform="translate(0 7.473)">
              <path
                fill="#597b8b"
                d="M0 0H1.429V14.551H0z"
                data-name="Rectangle 4774"
                transform="rotate(-46.528 1.206 .518)"
              ></path>
            </g>
          </g>
        </g>
        <path
          fill="#a7bcc8"
          d="M399.042 125.868a.891.891 0 00-1.159-.5 8.048 8.048 0 00-1.643.884c-2.186 1.523-3.507 4.041-4.475 6.918-3.32-1.752-6.659-2.723-9.929-1.425-5.045 2.006-6.556 8.1-8.017 14-.33 1.334-.657 2.648-1.016 3.906-1.089-.65-2.195-1.361-3.314-2.08-5.159-3.318-10.494-6.751-15.633-4.709-3.25 1.291-4.954 4.188-6.086 7.618-3.206-1.713-6.472-2.629-9.79-1.311a.893.893 0 10.659 1.659c2.8-1.113 5.661-.241 8.611 1.395-.395 1.459-.721 2.979-1.045 4.484-.095.438-.187.875-.284 1.311a.893.893 0 00.68 1.063.883.883 0 00.191.021.892.892 0 00.872-.7c.1-.438.191-.879.284-1.318.288-1.338.572-2.657.893-3.915 1.152.721 2.318 1.525 3.5 2.339 3.886 2.675 7.876 5.424 11.917 5.424a8.414 8.414 0 003.15-.6c3.35-1.332 5.165-4.413 6.431-8.047 3.4 1.777 6.809 2.788 10.119 1.472 5.092-2.023 6.529-8.165 7.92-14.106.3-1.28.6-2.573.945-3.822 1.138.693 2.293 1.455 3.465 2.231l.43.284a.893.893 0 00.984-1.491l-.43-.284c-1.3-.859-2.609-1.725-3.925-2.506.877-2.707 2.041-5.041 3.909-6.345a6.377 6.377 0 011.282-.689.886.886 0 00.504-1.161zm-32.286 32.8c-4.229 1.68-8.681-1.386-13.4-4.632-1.325-.913-2.663-1.832-4.011-2.652 1-3.2 2.439-5.781 5.166-6.865 4.284-1.7 9.008 1.336 14.006 4.55 1.239.8 2.488 1.6 3.741 2.331-1.131 3.4-2.679 6.147-5.503 7.269zm23.389-19.428c-1.347 5.747-2.616 11.176-6.842 12.855-2.777 1.1-5.767.155-8.906-1.536.423-1.43.791-2.913 1.155-4.384 1.414-5.711 2.75-11.1 6.942-12.771 2.747-1.091 5.672-.173 8.736 1.5-.402 1.413-.744 2.881-1.085 4.337z"
          data-name="Path 1857"
          transform="translate(-105.704)"
        ></path>
        <path
          fill="#3aaa35"
          d="M614.273 229.942l2.254-.011-1.363 1.8.705 2.141-2.129-.743-1.818 1.334.048-2.254-1.831-1.318 2.159-.652.686-2.147z"
          data-name="Path 1858"
          transform="translate(-329.724 -84.448)"
        ></path>
        <path
          fill="#e40134"
          d="M544.811 164.981l-.927 2.768-1.634-2.42-2.92-.025 1.8-2.3-.879-2.784 2.745 1 2.377-1.7-.1 2.918 2.346 1.736z"
          data-name="Path 1859"
          transform="translate(-271.56 -28.105)"
        ></path>
        <path
          fill="#007bc4"
          d="M420.884 210.43l-1.877 1.014.338-2.107-1.545-1.473 2.109-.33.923-1.923.964 1.9 2.116.284-1.512 1.505.384 2.1z"
          data-name="Path 1860"
          transform="translate(-171.733 -65.978)"
        ></path>
        <path
          fill="#ffd500"
          d="M488.207 299.583l2.156 1.916-2.832.547-1.155 2.641-1.395-2.523-2.87-.284 1.97-2.105-.618-2.818 2.613 1.223 2.488-1.459z"
          data-name="Path 1861"
          transform="translate(-224.559 -140.835)"
        ></path>
      </g>
    </svg>
  );
}

export default LogoDark;
